import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { NavLink } from "react-router-dom"
import Loader from "../subsidiary/Loader/Loader"
import NewsItem from "./components/NewsItem/NewsItem"
import styles from "./News.module.css"
import { fetchNews, searchNews } from "./newsSlice"
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search';
import Zoom from '@mui/material/Zoom';
const News = () => {
    const news = useSelector(state => state.newsSlice.news)
    // const isLoaded = useSelector(state => state.newsSlice.isLoaded)
    const [firstLoaded, setFirstLoaded] = useState(false)
    const [search, setSearch] = useState(null)
    const [checked, setChecked] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchNews()).then(() => {
            setFirstLoaded(true)
        })
    }, [dispatch])

    const searchHandler = (e) => {
        setSearch(e.target.value)
        if (e.target.value.length > 0) {
            dispatch(searchNews(search))
        }

        else {
            dispatch(fetchNews())
        }
    }
    const switchSearch = () => {
        setChecked(!checked)
    }

    return (
        <>
            {firstLoaded ?
                <>
                    <section className="main">
                        <div className="content-wrapper">
                            <div className="page-title-container">
                                {checked ? null :
                                    <Zoom in={!checked}>
                                        <h1 className="page-title ">
                                            Новости
                                        </h1>
                                    </Zoom>
                                }
                                {!checked ? null :
                                    <Zoom in={checked}>
                                        <FormControl className={styles.input} >
                                            <TextField
                                                value={search}
                                                type='text'
                                                onChange={searchHandler}
                                                name="search" id={'search'}
                                                label={`Введите текст`}
                                                placeholder=""
                                                variant="outlined"
                                                autoFocus
                                                sx={{
                                                    ".MuiOutlinedInput-root": {
                                                        background: "#F0F1F6",
                                                    },

                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <SearchIcon style={{ opacity: '50%' }} />
                                                    )
                                                }}
                                            />

                                        </FormControl>
                                    </Zoom>
                                }
                                {checked ? <div onClick={switchSearch} className='close'>Закрыть</div> :
                                    <SearchIcon onClick={switchSearch} style={{ opacity: '50%', cursor: 'pointer' }} />
                                }
                            </div>
                            <div className={styles.newsContainer}>
                                {news.length > 0
                                    ? news.map((item, i) => (
                                        <NavLink
                                            key={i.toString()}
                                            to={`/news/${item.id}`}
                                            className={styles.newsLink}
                                        >
                                            <NewsItem data={item} />
                                        </NavLink>
                                    ))
                                    : <div>По вашему запросу не найдено новостей</div>}
                            </div>
                        </div>
                    </section>
                </>
                : <Loader />}
        </>
    )

}
export default News
